<!-- @format -->

<template>
	<v-dialog :value="valor" persistent max-width="460">
		<v-card>
			<v-card-title class="subtitle-1">{{ titulo }}</v-card-title>
			<v-card-text>
				<v-progress-linear
					:value="porcentaje"
					height="18"
					color="primary"
					class="mb-3"
					rounded
				>
					<span class="caption white--text">{{ hechas }} de {{ total }}</span>
				</v-progress-linear>

				<div v-if="errores.length" class="mt-2">
					<div class="body-2 error--text mb-1">
						{{ errores.length }} no se pudo{{ errores.length > 1 ? 'ieron' : '' }}
						procesar:
					</div>
					<div class="lista-errores">
						<div v-for="error in errores" :key="error.clave" class="caption">
							OT {{ error.folio }} — {{ error.motivo }}
						</div>
					</div>
				</div>
				<div v-else-if="terminado" class="body-2 success--text">
					Listo, sin errores.
				</div>
			</v-card-text>
			<v-card-actions>
				<v-btn
					v-if="errores.length && terminado"
					text
					color="primary"
					class="text-none"
					@click="$emit('reintentar')"
				>
					Reintentar fallidas
				</v-btn>
				<v-spacer />
				<v-btn v-if="!terminado" text class="text-none" @click="$emit('cancelar')">
					Cancelar
				</v-btn>
				<v-btn v-else text color="primary" class="text-none" @click="$emit('cerrar')">
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'WorkOrderBulkProgress',
	props: {
		valor: { type: Boolean, default: false },
		titulo: { type: String, default: 'Procesando' },
		hechas: { type: Number, default: 0 },
		total: { type: Number, default: 0 },
		errores: { type: Array, default: () => [] },
		terminado: { type: Boolean, default: false },
	},
	computed: {
		porcentaje() {
			return this.total ? (this.hechas / this.total) * 100 : 0;
		},
	},
};
</script>

<style scoped>
.lista-errores {
	max-height: 140px;
	overflow-y: auto;
}
</style>
